function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgWrongGenderedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Ebene 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.54 28.54"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M-1656.13-1911.44a14.27 14.27 0 0 0-20.18 0 14.27 14.27 0 0 0 0 20.18 14.26 14.26 0 0 0 20.18 0 14.26 14.26 0 0 0 0-20.18Zm-5.72 12.45a1.42 1.42 0 0 1 0 2 1.42 1.42 0 0 1-1 .41 1.43 1.43 0 0 1-1-.41l-2.36-2.36-2.35 2.36a1.47 1.47 0 0 1-1 .41 1.45 1.45 0 0 1-1-.41 1.42 1.42 0 0 1 0-2l2.35-2.36-2.35-2.35a1.42 1.42 0 0 1 0-2 1.42 1.42 0 0 1 2 0l2.35 2.35 2.36-2.35a1.41 1.41 0 0 1 2 0 1.42 1.42 0 0 1 0 2l-2.35 2.35Z",
  transform: "translate(1680.49 1915.62)",
  style: {
    fill: "#3f3f3f"
  }
}));

export default SvgWrongGenderedIcon;